import { DisplayRequestType } from './approvals';

export const DEFAULT_REQUEST_TYPE_FILTER_SELECTED = 'All request types';

export const DEFAULT_STATUS_FILTER_SELECTED = 'All statuses';

export const REQUEST_TYPE = [
  DisplayRequestType.TRIAL_EXTENSION,
  DisplayRequestType.SUBSCRIPTION_REFUND,
  DisplayRequestType.TAX_REFUND,
  DisplayRequestType.ORDER_DISCOUNT,
  DisplayRequestType.PRODUCT_DELETION,
  DisplayRequestType.QUOTE_DISCOUNT,
  DisplayRequestType.QUOTE_EXTENSION,
  DisplayRequestType.PRICING_PLAN_CHANGE,
  DisplayRequestType.CLOUD_SITE_DELETION,
];
